/**
 * Custom Design page hero: auto-advancing project gallery.
 *
 * Advances every ~4s, pauses on hover or keyboard focus (and while
 * the tab is hidden), and respects prefers-reduced-motion by simply
 * showing the first slide with no rotation at all. Multiple galleries
 * per page are supported (each [data-pl-hero-gallery] runs its own
 * independent timer).
 */
(function () {
  function initGallery(gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.pl-chero__slide'));
    var controls = Array.prototype.slice.call(gallery.querySelectorAll('.pl-chero__controls button'));
    if (!slides.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      controls.forEach(function (control, i) {
        control.classList.toggle('is-active', i === current);
        control.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    function start() {
      if (reduceMotion) return;
      clearInterval(timer);
      timer = setInterval(function () {
        show(current + 1);
      }, 4200);
    }

    function stop() {
      clearInterval(timer);
    }

    controls.forEach(function (control, i) {
      control.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);
    gallery.addEventListener('focusin', stop);
    gallery.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    show(0);
    start();
  }

  function init() {
    document.querySelectorAll('[data-pl-hero-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
